import React from "react";
import { useTranslation } from "react-i18next";

export function Privacy() {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <h1 className="cc-h1">{t("title.privacyAndCookie")}</h1>
            <div style={{ textAlign: "justify" }}>
                <p>{t("description.privacy.p1")}</p>

                <h2>{t("description.privacy.h1")}</h2>
                <p>{t("description.privacy.p2")}</p>

                <h2>{t("description.privacy.h2")}</h2>
                <p>{t("description.privacy.p3")}</p>

                <h2>{t("description.privacy.h3")}</h2>
                <p>{t("description.privacy.p4")}</p>

                <h2>{t("description.privacy.h4")}</h2>
                <p>{t("description.privacy.p5")}</p>

                <h2>{t("description.privacy.h5")}</h2>
                <p>{t("description.privacy.p6")}</p>

                <p>{t("description.privacy.p7")}</p>

                <p>{t("description.privacy.p8")}</p>
            </div>
        </React.Fragment>
    );
}